'use strict';

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

var _themeA11y = require('@shopify/theme-a11y');

var _themeCart = require('@shopify/theme-cart');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('slick-carousel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Common a11y fixes
(0, _themeA11y.focusHash)();
(0, _themeA11y.bindInPageLinks)();

// Apply a specific class to the html element for browser support of cookies.
if ((0, _themeCart.cookiesEnabled)()) {
  document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
}

var ANIMATE_TIME = 300;

(0, _jquery2.default)('.hidden').hide();
(0, _jquery2.default)('.quick-hidden').hide();
(0, _jquery2.default)('.child-hidden').hide();

// nav toggles

function closeNav() {
  (0, _jquery2.default)('.expanded').removeClass('expanded').next('.hidden').slideToggle(ANIMATE_TIME);
}

(0, _jquery2.default)('.trigger').on('click', function () {
  var isOpen = (0, _jquery2.default)(this).hasClass('expanded');

  if (isOpen) {
    closeNav();
    return;
  }

  closeNav();

  (0, _jquery2.default)(this).addClass('expanded').next('.hidden').slideToggle(ANIMATE_TIME);
});

function closeChildNav() {
  (0, _jquery2.default)('.child-expanded').removeClass('child-expanded').next('.child-hidden').slideToggle(ANIMATE_TIME);
}

(0, _jquery2.default)('.child-trigger').on('click', function () {
  var isOpen = (0, _jquery2.default)(this).hasClass('child-expanded');

  if (isOpen) {
    closeChildNav();
    return;
  }

  closeChildNav();

  (0, _jquery2.default)(this).addClass('child-expanded').next('.child-hidden').slideToggle(ANIMATE_TIME);
});

// quick view

function initQuickView() {
  (0, _jquery2.default)('.quick-trigger').unbind('click');
  (0, _jquery2.default)('.quick-close').unbind('click');
  (0, _jquery2.default)('.quick-trigger').on('click', openQuickView);
  (0, _jquery2.default)('.quick-close').on('click', closeQuickView);
}

function openQuickView() {
  (0, _jquery2.default)(this).parent().next('.quick-hidden').fadeToggle(ANIMATE_TIME);

  (0, _jquery2.default)(".quick-view .slick").slick("refresh");
}

function closeQuickView() {
  (0, _jquery2.default)('.quick-hidden').fadeOut(ANIMATE_TIME);
}

initQuickView();

// product tabs

function closeTab() {
  (0, _jquery2.default)('.expanded').removeClass('expanded').next('.tab-hidden').slideToggle(ANIMATE_TIME);
}

(0, _jquery2.default)('.tab-trigger').on('click', function () {
  var isOpen = (0, _jquery2.default)(this).hasClass('expanded');

  if (isOpen) {
    closeTab();
    return;
  }

  closeTab();

  (0, _jquery2.default)(this).addClass('expanded').next('.tab-hidden').slideToggle(ANIMATE_TIME);
});

// mobile menu

var bodyScrollLock = require('body-scroll-lock');
var disableBodyScroll = bodyScrollLock.disableBodyScroll;
var enableBodyScroll = bodyScrollLock.enableBodyScroll;

var overlay = (0, _jquery2.default)('.mm-overlay');

(0, _jquery2.default)('.mm-trigger').click(function (e) {
  document.documentElement.classList.toggle('nav-is-open');
  if (!document.documentElement.classList.contains('nav-is-open')) {
    enableBodyScroll(overlay);
  } else {
    disableBodyScroll(overlay);
  }
  (0, _jquery2.default)(this).toggleClass('open');
  overlay.toggleClass('open hidden');
});

(0, _jquery2.default)('.mm-close').click(function () {
  overlay.toggleClass('open hidden');
});

// init slick

var $heroSlider = (0, _jquery2.default)('.hero-slider .slick');
var $featSlider = (0, _jquery2.default)('.featured-products .slick');
var $quickSlider = (0, _jquery2.default)('.quick-view .slick');
var $quickNavSlider = (0, _jquery2.default)('.quick-view .slick-nav');

var heroSettings = {
  fade: true,
  cssEase: 'linear',
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 6000,
  speed: 1200,
  pauseOnFocus: true
};

var featSettings = {
  infinite: true,
  dots: false,
  arrows: true,
  autoplay: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 800,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1
    }
  }, {
    breakpoint: 675,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }]
};

var quickSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: true,
  arrows: false
};

$heroSlider.slick(heroSettings);
$featSlider.slick(featSettings);
$quickSlider.slick(quickSettings);

// support page tabs

(0, _jquery2.default)('.support-menu button').click(function () {
  var tab_id = (0, _jquery2.default)(this).attr('data-tab');

  (0, _jquery2.default)('.support-menu button').removeClass('current');
  (0, _jquery2.default)('.tab-content').removeClass('current');

  (0, _jquery2.default)(this).addClass('current');
  (0, _jquery2.default)("#" + tab_id).addClass('current');
});

// infinite scroll

document.addEventListener('DOMContentLoaded', function () {
  var endlessScroll = new Ajaxinate({
    container: '.product-grid',
    pagination: '.product-paginate',
    method: 'click',
    callback: initQuickView
  });
});

// variant swatches

(0, _jquery2.default)('.swatch :radio').change(function () {
  var optionIndex = (0, _jquery2.default)(this).closest('.swatch').attr('data-option-index');
  var optionValue = (0, _jquery2.default)(this).val();
  (0, _jquery2.default)(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
});